import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import MaintenanceRoutineForm from "components/maintenanceRoutines/MaintenanceRoutineForm";
import { updateMaintenanceRoutine } from "graphql/mutations";
import { getMaintenanceRoutine } from "graphql/queries";

const MaintenanceRoutineUpdateForm = ({ maintenanceRoutineId, onSuccess }) => {
  const navigate = useNavigate();
  const [maintenanceRoutine, setMaintenanceRoutine] = useState();

  async function onSubmit(valuesParam) {
    try {
      const { name, description, companyID } =
        valuesParam;

      await API.graphql({
        query: updateMaintenanceRoutine.replaceAll("__typename", ""),
        variables: {
          input: {
            id: maintenanceRoutineId,
            name,
            description,
            companyID,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/maintenance-routines");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchMaintenanceRoutine(id) {
    try {
      const maintenanceRoutineData = await API.graphql(graphqlOperation(getMaintenanceRoutine, { id }));
      const maintenanceRoutineItem = maintenanceRoutineData.data.getMaintenanceRoutine;
      if (!maintenanceRoutineItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/maintenance-routines");
        return;
      }
      setMaintenanceRoutine({
        ...maintenanceRoutineItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchMaintenanceRoutine(maintenanceRoutineId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maintenanceRoutineId]);

  if (!maintenanceRoutine) return <Loader />;

  return (
    <div>
      <MaintenanceRoutineForm onSubmit={onSubmit} type="update" initialValues={maintenanceRoutine} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Rutina de Mantenimiento",
    successUpdated: "Rutina de Mantenimiento actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar la rutina de mantenimiento",
    },
  },
});

export default MaintenanceRoutineUpdateForm;
